export class WaterMeasure {

    Distance: number;
    Profondeur: number;
    V02P: number;
    V04P: number;
    V08P: number;

    static mapFromJSON(json): any {
        const w = new WaterMeasure();

        w.Distance = json.distance;
        w.Profondeur = json.profondeur;
        w.V02P = json.v02P;
        w.V04P = json.v04P;
        w.V08P = json.v08P;

        return w;
    }
}
